import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

export const SECURITY_ELEMENT_ID = 'securityRoute'

const SecurityRoute = lazyWithRetries(() => import('./index'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.security(),
    element: (
      <StandardPageLayout
        maxWidth={900}
        elementId={SECURITY_ELEMENT_ID}
        title={<T _str="Security & access" />}>
        <Suspense fallback={<RouteLoading />}>
          <SecurityRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
